<div class="snackbar">
  <img class="icon" src="../assets/images/notification-icon.svg" alt="">
  <span>
    {{ data }}
  </span>

  <span class="cancel" (click)="snackBarRef.dismissWithAction()">
    Close
  </span>
</div>


